export default {
	"api.password.update.success": "Пароль успешно обновлён",
	"api.profile.update.error": "Ошибка при обновлении:",
	"api.profile.update.success": "Профиль обновлён",
	"common.boolean.false": "НЕТ",
	"common.boolean.true": "ДА",
	"common.cancel": "Отмена",
	"dashboard.activityLog.description": "Недавние события вашего проекта",
	"dashboard.activityLog.title": "Журнал активности",
	"dashboard.errorsChart.description": "Ответы 4xx и 5xx",
	"dashboard.errorsChart.title": "Ошибки по дням",
	"dashboard.quotas.bandwidth": "Трафик",
	"dashboard.quotas.database": "База данных",
	"dashboard.quotas.description": "Использование лимитов тарифа",
	"dashboard.quotas.edgeInvocations": "Вызовы Edge",
	"dashboard.quotas.storage": "Хранилище",
	"dashboard.quotas.title": "Квоты",
	"dashboard.recentUsers.column.email": "Email",
	"dashboard.recentUsers.column.joined": "Регистрация",
	"dashboard.recentUsers.column.provider": "Провайдер",
	"dashboard.recentUsers.column.status": "Статус",
	"dashboard.recentUsers.description": "Последние регистрации через провайдеров авторизации",
	"dashboard.recentUsers.title": "Новые пользователи",
	"dashboard.stats.activeUsers.hint": "за последние 7 дней",
	"dashboard.stats.activeUsers.label": "Активные пользователи",
	"dashboard.stats.apiRequests.hint": "за последние 24 часа",
	"dashboard.stats.apiRequests.label": "API-запросы",
	"dashboard.stats.databaseSize.hint": "из 8 ГБ по тарифу",
	"dashboard.stats.databaseSize.label": "Размер БД",
	"dashboard.stats.errorRate.hint": "за последние 24 часа",
	"dashboard.stats.errorRate.label": "Доля ошибок",
	"dashboard.tablesOverview.column.rows": "Строки",
	"dashboard.tablesOverview.column.size": "Размер",
	"dashboard.tablesOverview.column.table": "Таблица",
	"dashboard.tablesOverview.description": "Крупнейшие таблицы схемы public по размеру",
	"dashboard.tablesOverview.title": "Таблицы базы данных",
	"dashboard.tablesOverview.viewAll": "Смотреть все",
	"dashboard.trafficChart.description": "Запросы за последние 7 дней",
	"dashboard.trafficChart.title": "Трафик API",
	"error.boundary.description":
		"Произошла непредвиденная ошибка. Обновите страницу или обратитесь в поддержку, если проблема повторяется.",
	"error.boundary.refresh": "Обновить страницу",
	"error.boundary.retry": "Повторить",
	"error.boundary.title": "Что-то пошло не так",
	"form.field.email.invalid": "Некорректный адрес электронной почты",
	"form.field.email.placeholder": "Введите email",
	"form.field.password.label": "Пароль",
	"form.field.password.min": "Минимум 6 символов",
	"form.field.password.placeholder": "********",
	"form.login.description": "Введите ваши учётные данные для продолжения.",
	"form.login.title": "Вход",
	"form.submit.loading": "Вход...",
	"form.submit.title": "Войти",
	"page.dashboard.title": "Дашборд",
	"page.help.title": "Помощь",
	"page.login.overview.activity": "Активность в реальном времени",
	"page.login.overview.growth": "Рост",
	"page.login.overview.live": "В эфире",
	"page.login.overview.requests": "Запросы",
	"page.login.overview.title": "Обзор проекта",
	"page.login.overview.users": "Пользователи",
	"page.notFound.back": "Назад",
	"page.notFound.code": "Ошибка 404",
	"page.notFound.description":
		"Страница не существует или была перемещена. Проверьте URL или вернитесь на дашборд.",
	"page.notFound.home": "На главную",
	"page.notFound.title": "Страница не найдена",
	"page.products.placeholder": "Страница продуктов",
	"page.profile.about-app.description": "Информация о текущей версии и сборке.",
	"page.profile.about-app.legal-information.copyright": "© {year} Lovable. Все права защищены.",
	"page.profile.about-app.legal-information.description": "Документы и ссылки.",
	"page.profile.about-app.legal-information.privacy-policy": "Политика конфиденциальности",
	"page.profile.about-app.legal-information.terms-of-use": "Условия использования",
	"page.profile.about-app.legal-information.title": "Юридическая информация",
	"page.profile.about-app.title": "О приложении",
	"page.profile.avatar.fileTooLarge": "Размер файла должен быть меньше 2 МБ",
	"page.profile.avatar.hint": "PNG, JPG или WEBP. Макс. 2 МБ.",
	"page.profile.avatar.upload": "Загрузить",
	"page.profile.dangerZone.button": "Удалить мой аккаунт",
	"page.profile.dangerZone.confirmAction": "Да, удалить мой аккаунт",
	"page.profile.dangerZone.confirmDescription":
		"Это навсегда удалит ваш аккаунт ({userId}…) и все связанные данные. Это действие нельзя отменить.",
	"page.profile.dangerZone.confirmTitle": "Удалить аккаунт?",
	"page.profile.dangerZone.deleteError": "Не удалось удалить аккаунт.",
	"page.profile.dangerZone.deleteSuccess":
		"Вы вышли из системы. Свяжитесь с поддержкой, чтобы завершить удаление.",
	"page.profile.dangerZone.deleting": "Удаление…",
	"page.profile.dangerZone.description":
		"Все ваши данные будут удалены безвозвратно. Это действие нельзя отменить.",
	"page.profile.dangerZone.title": "Удаление аккаунта",
	"page.profile.general.email": "Email",
	"page.profile.general.firstName": "Имя",
	"page.profile.general.lastName": "Фамилия",
	"page.profile.general.save": "Сохранить",
	"page.profile.general.title": "Общие",
	"page.profile.profile.subTitle": "Личные данные и контакты",
	"page.profile.profile.title": "Профиль",
	"page.profile.security.changePassword": "Сменить пароль",
	"page.profile.security.changePasswordDescription": "Обновите пароль аккаунта",
	"page.profile.security.confirmPassword": "Подтвердите пароль",
	"page.profile.security.newPassword": "Новый пароль",
	"page.profile.security.subTitle": "Действия и события безопасности аккаунта",
	"page.profile.security.title": "Безопасность",
	"page.profile.security.updatePassword": "Обновить пароль",
	"page.profile.sessions.description": "Устройства, на которых выполнен вход в ваш аккаунт.",
	"page.profile.sessions.signOutError": "Не удалось завершить другие сессии.",
	"page.profile.sessions.signOutOthers": "Выйти на всех других устройствах",
	"page.profile.sessions.signOutSuccess": "Выход выполнен на всех других устройствах.",
	"page.profile.sessions.signingOut": "Выход…",
	"page.profile.sessions.title": "Активные сессии",
	"page.profile.settings.dateFormat": "Формат даты",
	"page.profile.settings.dateFormatDescription": "Как отображать даты",
	"page.profile.settings.headerSticky": "Закрепить шапку",
	"page.profile.settings.headerStickyDescription": "Сделать шапку страницы закреплённой (sticky)",
	"page.profile.settings.language": "Язык",
	"page.profile.settings.language.en": "Английский",
	"page.profile.settings.language.ru": "Русский",
	"page.profile.settings.languageDescription": "Язык",
	"page.profile.settings.sidebarCollapsible": "Сворачиваемость боковой панели",
	"page.profile.settings.sidebarCollapsible.icon": "Иконки",
	"page.profile.settings.sidebarCollapsible.none": "Без сворачивания",
	"page.profile.settings.sidebarCollapsible.offcanvas": "Выезжающая",
	"page.profile.settings.sidebarCollapsibleDescription": "Способ сворачивания бокового меню",
	"page.profile.settings.sidebarVariant": "Вариант боковой панели",
	"page.profile.settings.sidebarVariant.floating": "Плавающая",
	"page.profile.settings.sidebarVariant.inset": "Встроенная",
	"page.profile.settings.sidebarVariant.sidebar": "Боковая панель",
	"page.profile.settings.sidebarVariantDescription": "Вариант отображения бокового меню",
	"page.profile.settings.subTitle": "Настройте язык и тему интерфейса.",
	"page.profile.settings.theme": "Тема",
	"page.profile.settings.themeField": "Выберите тему оформления",
	"page.profile.settings.title": "Настройки",
	"page.profile.signOut": "Выйти",
	"page.storage.buckets.description": "Выберите для просмотра",
	"page.storage.buckets.private": "приватный",
	"page.storage.buckets.public": "публичный",
	"page.storage.buckets.title": "Бакеты",
	"page.storage.createBucket.description":
		"Бакеты хранят файлы. Настройте доступ и ограничения ниже.",
	"page.storage.createBucket.mimeHint": "Через запятую. Допускаются шаблоны вроде image/*.",
	"page.storage.createBucket.mimeLabel": "Разрешённые MIME-типы",
	"page.storage.createBucket.mimePlaceholder": "image/png, image/jpeg, application/pdf",
	"page.storage.createBucket.nameHint": "Имя бакета должно быть в нижнем регистре без пробелов.",
	"page.storage.createBucket.nameLabel": "Имя бакета",
	"page.storage.createBucket.namePlaceholder": "например, avatars",
	"page.storage.createBucket.publicHint":
		"Любой с URL может просматривать файлы. RLS по-прежнему применяется к записи.",
	"page.storage.createBucket.publicLabel": "Публичный бакет",
	"page.storage.createBucket.restrictHint": "Ограничить загружаемые MIME-типы.",
	"page.storage.createBucket.restrictLabel": "Ограничить типы файлов",
	"page.storage.createBucket.sizeHint": "Оставьте пустым, если лимит не нужен.",
	"page.storage.createBucket.sizeLabel": "Лимит размера файла",
	"page.storage.createBucket.sizePlaceholder": "например, 50",
	"page.storage.createBucket.submit": "Создать бакет",
	"page.storage.createBucket.title": "Создать новый бакет",
	"page.storage.empty.action": "Новый бакет",
	"page.storage.empty.description":
		"Бакеты — контейнеры для файлов. Создайте первый бакет, чтобы начать загрузку и управление файлами.",
	"page.storage.empty.title": "Бакетов пока нет",
	"page.storage.files.column.modified": "Изменён",
	"page.storage.files.column.name": "Имя",
	"page.storage.files.column.size": "Размер",
	"page.storage.files.count": "{count} файлов",
	"page.storage.files.empty": "В этом бакете нет файлов",
	"page.storage.files.filter": "Фильтр",
	"page.storage.files.searchPlaceholder": "Поиск файлов…",
	"page.storage.files.upload": "Загрузить",
	"page.storage.stats.bandwidth": "Трафик (24ч)",
	"page.storage.stats.bandwidthPlan": "из 250 ГБ по тарифу",
	"page.storage.stats.buckets": "Бакеты",
	"page.storage.stats.bucketsBreakdown": "{publicCount} публичных · {privateCount} приватных",
	"page.storage.stats.liveFromSupabase": "Данные из Supabase",
	"page.storage.stats.totalFiles": "Всего файлов",
	"page.storage.stats.totalStorage": "Общий объём",
	"page.storage.title": "Хранилище",
	"page.tables.index.description":
		"Выберите таблицу в боковом меню, чтобы просматривать и управлять записями.",
	"page.users.description": "Управляйте аккаунтами и доступами.",
	"page.users.empty": "Пользователей пока нет.",
	"page.users.title": "Пользователи",
	"project.name": "Панель {name}",
	"project.rights": "© {date} Панель {name}. Все права защищены",
	"sidebar.tables.label": "Таблицы",
	"table.action.delete": "Удалить",
	"table.action.edit": "Изменить",
	"table.create": "Создать",
	"table.creating": "Создание",
	"table.creating_description": "Добавление записи в таблицу {resource}",
	"table.editing": "Редактирование",
	"table.editing_description": "Редактирование записи {id} из таблицы {resource}",
	"table.empty.action": "Добавить запись",
	"table.empty.description": "Добавьте первую запись, чтобы начать",
	"table.empty.title": "Записей не найдено",
	"table.noSearchResults": "Нет результатов по вашему запросу.",
	"table.pagination.page": "Страница {current} из {total}",
	"table.pagination.rowsPerPage": "Строк на странице",
	"table.pagination.showing": "Показано {from} - {to} из {total}",
	"table.search.fieldFallback": "поле",
	"table.search.fieldPlaceholder": "Поле",
	"table.search.placeholder": "Поиск по {field}...",
	"table.selectAll": "Выбрать все",
	"table.selectRow": "Выбрать строку",
	"table.selectedCount": "Выбрано: {count}",
	"validation.password.match": "Пароли не совпадают",
	"validation.password.min": "Минимум 8 символов",
};
